export const SET_CONTACT_ID = 'SET_CONTACT_ID'
export const SET_TOKEN = 'SET_TOKEN'
export const GET_CONTACT_ID = 'GET_CONTACT_ID'
export const GET_TOKEN = 'GET_TOKEN'
export const EXEC_AUTH = 'EXEC_AUTH'
export const EXEC_WIDGET = 'EXEC_WIDGET'
export const OPENS_MODULE = 'opens'
